import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { SecretService } from '../services/secret.service';

export const debugInterceptor: HttpInterceptorFn = (req, next) => {
  const secretService = inject(SecretService);
  if (!secretService.betterErrors) {
    return next(req);
  }

  // using X-Requested-With because it is a normal header but not for this use.
  const modifiedRequest = req.clone({
    setHeaders: { 'X-Requested-With': 'show-me-errors' },
  });

  // Pass the modified request to the next handler
  return next(modifiedRequest);
};
